import { render, staticRenderFns } from "./MiniCart.vue?vue&type=template&id=c31be8ae&scoped=true"
import script from "./MiniCart.vue?vue&type=script&lang=js"
export * from "./MiniCart.vue?vue&type=script&lang=js"
import style0 from "./MiniCart.vue?vue&type=style&index=0&id=c31be8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31be8ae",
  null
  
)

export default component.exports